import { returnDateTime } from "../../../../utils/dateFormatUrils";
import CarouselComponent from "../BizzList";

// Function to render business listings as a carousel
const renderBizzListings = (bizzListings, bizz_value) => {
  const filteredBizz = bizzListings.filter(
    (bizz) => bizz.bizz_value === bizz_value
  );
  if (filteredBizz.length === 0) return null;

  return <CarouselComponent items={filteredBizz} />;
};
// Function to create combined listings
const createCombinedListings = (finalLcaAndBwv) => {
  const combinedListings = [];
  finalLcaAndBwv.forEach((ad, index) => {
    combinedListings.push({ type: "ad", data: ad });
    // Insert business listings after 3rd, 6th, and 9th ad
    if (index + 1 === 3) {
      combinedListings.push({ type: "bizz", bizz_value: 1 });
    } else if (index + 1 === 6) {
      combinedListings.push({ type: "bizz", bizz_value: 2 });
    } else if (index + 1 === 9) {
      combinedListings.push({ type: "bizz", bizz_value: 3 });
    }
  });
  return combinedListings;
};

export { renderBizzListings, createCombinedListings };
